import {BiArrowBack} from 'react-icons/bi'
import { Link } from 'react-router-dom'
import './componentsStyle.css'
import { useTranslation } from "react-i18next";
const BackButton = () => {
    const { t } = useTranslation();
    const style = { color: "#646363", marginRight:"8px" ,with:"14px", height:"14px", marginTop:"4px" }
  return(<div className='elements-container'>
    <BiArrowBack style={style}/>
    <Link to="/" >{t("template_button_back_to_home")}</Link>
  </div>)
}

export default BackButton